var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMarca1(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_2",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 138.79 153.07",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#f9f8fe;}.cls-2{fill:#c30602;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Capa_1"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "0 0 46.94 47.61 48.31 56.61 59.95 67.76 61.53 75.03 69.6 83.69 77.6 75.53 79.58 67 90.58 56.37 91.7 47.66 138.79 0 138.79 17.68 126.43 33.13 125.57 44.13 74.02 99.26 81.06 110.76 58.07 110.76 65 99.26 13.57 44.5 12.71 33.25 0 17.17 0 0"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "9.74 15.7 43.36 49.82 44.35 57.97 55.11 68.85 42.5 62.55 40.64 52.16 9.74 15.7"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "129.61 15.7 95.99 49.82 95 57.97 84.24 68.85 96.85 62.55 98.71 52.16 129.61 15.7"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "66.58 100.8 69.6 106.14 72.27 101.03 69.57 104.24 66.58 100.8"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M63.67,134.89c.19-.13,12.13-16.35,12.13-16.35h12.39l-11.81,16.35h-12.72Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M63.66,136.72c.2,.13,12.37,16.35,12.37,16.35l12.62-.02-12.04-16.35-12.95,.02Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "51.08 118.54 62.24 133.92 62.76 133.2 57.7 125.94 63.15 132.55 63.67 132.03 58.8 125.55 63.99 131.39 64.32 130.87 60.23 124.9 64.71 130.28 65.1 129.76 61.2 124.25 65.42 129.11 65.94 128.53 62.44 123.6 66.39 128.14 66.91 127.49 63.67 123.08 67.17 127.04 67.69 126.23 65.1 122.5 68.02 125.81 68.6 125.35 63.67 118.54 51.08 118.54"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "51.08 153.07 62.24 137.7 62.76 138.41 57.7 145.68 63.15 139.06 63.67 139.58 58.8 146.07 63.99 140.23 64.32 140.75 60.23 146.71 64.71 141.33 65.1 141.85 61.2 147.36 65.42 142.5 65.94 143.08 62.44 148.01 66.39 143.47 66.91 144.12 63.67 148.53 67.17 144.57 67.69 145.38 65.1 149.11 68.02 145.81 68.6 146.26 63.67 153.07 51.08 153.07"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMarca1);
export default __webpack_public_path__ + "static/media/marca1.01ecd7f91e439635ca9b6a0e253c4ce9.svg";
export { ForwardRef as ReactComponent };